import React from 'react';
import { SkeletonText, Tile } from 'carbon-components-react';

const StripePaymentCardSkeleton: React.FC = () => {
  return (
    <Tile
      className="stripe-payment-card"
      aria-busy="true"
      aria-label="Loading payment amount"
    >
      <div className="stripe-payment-card__label">STRIPE</div>
      <div className="stripe-payment-card__amount">
        <div className="stripe-payment-card-skeleton__amount-wrap">
          <SkeletonText width="100%" />
        </div>
      </div>
      <div className="stripe-payment-card-skeleton__description-wrap">
        <SkeletonText width="100%" />
      </div>
    </Tile>
  );
};

export default StripePaymentCardSkeleton;
